module.exports = __webpack_public_path__ + "static/media/GT Walsheim Pro Regular.44178125.ttf";